import styled from "styled-components";
import axios from "axios";
import url from "../../../../Component/server";
import { ActionButton, ControlRow, Field, FieldLabel, FieldStack, FormInput, HelperText, Required } from "./SignupForm.styles";

interface Step1Props {
  storeName: string;
  handleStoreName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setStoreNameCheck: (value: boolean) => void;
  name: string;
  handleName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  phoneNum: string;
  handlePhoneNum: (e: React.ChangeEvent<HTMLInputElement>) => void;
  email: string;
  handleEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  domain: string;
  handleDomain: (e: React.ChangeEvent<HTMLInputElement> | string) => void;
  selectDomain: string;
  handleSelectDomain: (data: string) => void;
  userid: string;
  setUserid: (value: string) => void;
  userpw: string;
  setUserpw: (value: string) => void;
  userpwConfirm: string;
  setUserpwConfirm: (value: string) => void;
}

const Step1 = ({
  storeName, handleStoreName, setStoreNameCheck,
  name, handleName, phoneNum, handlePhoneNum, email, handleEmail,
  domain, handleDomain, selectDomain, handleSelectDomain,
  userid, setUserid, userpw, setUserpw, userpwConfirm, setUserpwConfirm,
}: Step1Props) => {
  const emailList = ["naver.com", "gmail.com", "hanmail.net", "daum.net", "직접입력"];
  const storeNameCheck = () => {
    const regex = /^[a-zA-Z0-9가-힣]{2,10}$/; // 영문, 숫자, 한글만 허용하며 길이는 2~10자
    if (storeName === "") {
      alert("스토어명을 입력해주세요.");
      return;
    }
    if (!regex.test(storeName)) {
      alert("스토어명은 영문, 숫자, 한글만 가능하며 2~10자로 입력해주세요.");
      return;
    }
    axios
      .get(url.Communication_url.store_name_dup_check, {
        params: { store_name: storeName },
      })
      .then((res) => {
        setStoreNameCheck(true);
        alert("사용 가능한 스토어명입니다.");
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message === "중복") {
          alert("이미 사용 중인 스토어명입니다.");
        }
      });
  };

  return (
    <Sections>
      <Field>
        <FieldLabel htmlFor="seller-store-name">스토어명 <Required>*</Required></FieldLabel>
        <ControlRow>
          <FormInput id="seller-store-name" type="text" placeholder="스토어명을 입력해주세요."
            value={storeName} onChange={handleStoreName} aria-describedby="seller-store-help" />
          <ActionButton type="button" onClick={storeNameCheck}>중복확인</ActionButton>
        </ControlRow>
        <HelperText id="seller-store-help">*고객들에게 보여지는 내 가게 이름입니다.</HelperText>
      </Field>
      <Section aria-labelledby="seller-account-title">
        <SectionTitle id="seller-account-title">셀러 로그인 계정</SectionTitle>
        <FieldStack>
          <Field>
            <FieldLabel htmlFor="seller-userid">계정 아이디 <Required>*</Required></FieldLabel>
            <FormInput id="seller-userid" type="text" autoComplete="username" minLength={4} maxLength={20}
              placeholder="로그인에 사용할 아이디를 입력해주세요." value={userid}
              onChange={event => setUserid(event.target.value)} aria-describedby="seller-userid-help" />
            <HelperText id="seller-userid-help">영문 또는 숫자로 시작하는 4~20자이며, 영문·숫자·_ . - 를 사용할 수 있습니다.</HelperText>
          </Field>
          <Field>
            <PasswordRow>
              <Field>
                <FieldLabel htmlFor="seller-password">비밀번호 <Required>*</Required></FieldLabel>
                <FormInput id="seller-password" type="password" autoComplete="new-password" minLength={5} maxLength={72}
                  placeholder="비밀번호" value={userpw} onChange={event => setUserpw(event.target.value)}
                  aria-describedby="seller-password-help" />
              </Field>
              <Field>
                <FieldLabel htmlFor="seller-password-confirm">비밀번호 확인 <Required>*</Required></FieldLabel>
                <FormInput id="seller-password-confirm" type="password" autoComplete="new-password" minLength={5} maxLength={72}
                  placeholder="비밀번호 재입력" value={userpwConfirm} onChange={event => setUserpwConfirm(event.target.value)} />
              </Field>
            </PasswordRow>
            <HelperText id="seller-password-help">대문자, 소문자, 숫자, 특수문자를 모두 포함해 5자 이상 입력해주세요.</HelperText>
          </Field>
        </FieldStack>
      </Section>
      <Section aria-labelledby="seller-representative-title">
        <SectionTitle id="seller-representative-title">대표자 정보</SectionTitle>
        <FieldStack>
          <Field>
            <FieldLabel htmlFor="seller-name">대표자명 <Required>*</Required></FieldLabel>
            <FormInput id="seller-name" type="text" placeholder="대표자명을 입력해주세요." value={name} onChange={handleName} />
          </Field>
          <Field>
            <FieldLabel htmlFor="seller-phone">연락처 <Required>*</Required></FieldLabel>
            <FormInput id="seller-phone" type="number" placeholder="- 를 제외한 연락처를 입력해주세요." value={phoneNum} onChange={handlePhoneNum} />
          </Field>
          <Field>
            <FieldLabel htmlFor="seller-email">이메일 <Required>*</Required></FieldLabel>
            <HelperText id="seller-email-help">고객들에게 문의 받을 이메일을 등록해주세요.</HelperText>
            <EmailRow>
              <FormInput id="seller-email" type="text" value={email} onChange={handleEmail} aria-describedby="seller-email-help" />
              <span aria-hidden="true">@</span>
              <FormInput type="text" aria-label="이메일 도메인" value={domain} onChange={handleDomain} disabled={selectDomain !== "직접입력"} />
            </EmailRow>
            <DomainSelect aria-label="이메일 도메인 선택" value={selectDomain} onChange={event => {
              const value = event.target.value;
              handleSelectDomain(value);
              handleDomain(value === "직접입력" ? "" : value);
            }}>
              <option value="" disabled>선택</option>
              {emailList.map(value => <option key={value} value={value}>{value}</option>)}
            </DomainSelect>
          </Field>
        </FieldStack>
      </Section>
    </Sections>
  );
};

export default Step1;

const Sections = styled.div`
  display: grid;
  gap: var(--space-8);
`;
const Section = styled.section`
  display: grid;
  gap: var(--space-5);
  padding-top: var(--space-8);
  border-top: 1px solid var(--color-border-default);
`;
const SectionTitle = styled.h2`
  margin: 0;
  font-size: var(--text-h3);
  line-height: var(--leading-h3);
  font-weight: var(--font-weight-semibold);
`;
const PasswordRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
`;
const EmailRow = styled(ControlRow)`
  gap: var(--space-2);
  color: var(--color-text-secondary);
`;
const DomainSelect = styled.select`
  width: 100%;
  height: var(--control-lg);
  padding: 0 var(--space-4);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  &&& { font-size: var(--text-body-lg); }
  cursor: pointer;
`;
